import { IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { useDeleteProcedure } from 'hooks/useProcedure';
import DeleteIcon from 'icons/DeleteIcon';
import { colors } from 'styles/colors';
import CustomText from 'components/common/CustomText/CustomText';
import CustomDialog from 'components/dialogs/CustomDialog';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { snackbarService } from 'services/snackbarService';
import { useDeleteRegistryPatients } from 'hooks/useRegistryPatient';
import { useRegistryContext } from 'context/RegistryContext';

interface Props {
  id: number;
  refetch?: () => void;
}

export default function DeleteRegistryPatientButton({ id, refetch }: Props) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { registry } = useRegistryContext();

  const { mutate: deleteMutation, isLoading } = useDeleteRegistryPatients(
    (res: any) => {
      refetch?.();
      setOpen(false);
      snackbarService.showSnackbar('Patient has been deleted successfully', 'success');
    },
    (error: any) => {
      setOpen(false);
    }
  );

  const handleConfirmDelete = () => {
    deleteMutation({
      registryId: registry.id,
      patientIds: [id],
    });
  };

  return (
    <>
      <Tooltip title="Delete">
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 25,
            height: 25,
            backgroundColor: colors.delete,
            borderRadius: '4px',
            padding: 0,
            '&:hover': {
              backgroundColor: colors.delete,
            },
          }}
        >
          <DeleteIcon size={12} color="white" />
        </IconButton>
      </Tooltip>

      <CustomDialog
        open={open}
        title={'Delete Patient'}
        message={'Note: Deleting this patient is permenant and cannot be undone.'}
        alignText='left'
        buttons={[
          <CustomButton
            key='cancel'
            variant='outlined'
            text='Cancel'
            textColor='error'
            onClick={() => setOpen(false)}
            disabled={isLoading}
            height={35}
          />,
          <CustomButton
            key='delete'
            variant='filled'
            color='error'
            text='Delete'
            onClick={handleConfirmDelete}
            loading={isLoading}
            height={35}
          />,
        ]}
      />
    </>
  );
}
